import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

interface AdminRouteProps {
  children?: ReactNode;
}

export const AdminRoute = ({ children }: AdminRouteProps) => {
  return children || <Outlet />;
};
